export async function deleteLsQuestion({ id, themeName, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/deleteLsQuestion`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ id, themeName }),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to delete question");
  }

  return resp.json();
}
